import { lifHttp, vcpodeHttp } from "@/http";
import { serialize } from "./utils";
import { rms } from './rms';
import { viacep } from './viacep';

const getOrdersUsers = (data = {}) => {
	const params = serialize({ ...data });
	return lifHttp.get(`orders/adm${params}`);
};

const getUserByDocument = (data = {}) => {
	const params = serialize({ ...data, isCompany: false });
	return lifHttp.get(`orders/adm${params}`);
};

const deactivateUser = (data) => lifHttp.delete(`order/${data.id}?cancel_reason=${data.cancel_reason}`);
const deactivateUserBankMaster = (id) => lifHttp.post(`cancel-order-bank-master/${id}`);
const reactivateUser = (id) => lifHttp.put(`sales/reactivate/${id}`);
const updateUser = (id, data) => lifHttp.put(`user/${id}`, data);

const removeDependent = (data) => vcpodeHttp.delete(`/order/${data.orderId}/deps/${data.dependentId}`);

const internalAddDependent = (data) => lifHttp.post('user/internal', data);
const sendNewPassword = (data) => lifHttp.post('email/password/new', data);
const updateOrder = (data) => lifHttp.put(`order/${data.id}/deps`, data);

const getCEP = (zipCode) => viacep.getCEP(zipCode);

export const userManagement = {
	getOrdersUsers,
	getUserByDocument,
	deactivateUser,
	deactivateUserBankMaster,
	reactivateUser,
	updateUser,
	checkRmsStatus: rms.checkRmsStatus,
	reprocessRms: rms.reprocessRms,
	removeDependent,
	internalAddDependent,
	sendNewPassword,
	updateOrder,
	getCEP,
};
